import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { Store } from '@ngrx/store';

import * as fromStore from '../../store';

import { StripEmbedPipe, getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { DatePipe, JsonPipe, SlicePipe } from '@angular/common';
import { HeaderComponent } from 'src/app/standalone/components/header/header.component';
import { EventPracticalInfoComponent } from '../../components/event-practical-info/event-practical-info.component';
import { BreadcrumbsComponent } from 'src/app/standalone/components/breadcrumbs/breadcrumbs.component';
import { EventDatePipe } from '../../pipes/event-date.pipe';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { SafePipe, StripHtmlPipe, UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { RouterLink } from '@angular/router';
import { LinkComponent } from '@teamfoster/sdk/button';
import { EventHeaderComponent } from '../../components/event-header/event-header.component';
import { EventMetadataComponent } from '../../components/event-metadata/event-metadata.component';
import { ContentBlockAgendaComponent } from 'src/app/content-blocks/components/content-block-agenda/content-block-agenda.component';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';
import { IconComponent } from '@teamfoster/sdk/icon';

@Component({
  selector: 'app-event-detail',
  templateUrl: './event-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./event-detail.component.scss'],
  imports: [
    EventHeaderComponent,
    EventPracticalInfoComponent,
    BreadcrumbsComponent,
    EventDatePipe,
    ResizeHtmlImagesPipe,
    StripEmbedPipe,
    FromDictionaryPipe,
    LinkComponent,
    EventMetadataComponent,
    LinkComponent,
    ContentBlockAgendaComponent,
    DynamicHooksModule,
    DatePipe,
    RouterLink,
    UrlRewritePipe,
    SlicePipe,
    IconComponent,
  ],
})
export class EventDetailComponent {
  private store = inject(Store);

  cookiePreferences$ = this.store.selectSignal(getCookiePreferences);

  event$ = this.store.selectSignal(fromStore.getSelectedEvent);
  relatedEvents$ = this.store.selectSignal(fromStore.getAllRelatedEvents);

  breadcrumbs = computed(() => {
    const event = this.event$();

    // console.log('Deps:', event?.departments);

    return [
      { text: 'Agenda', routerLink: ['/agenda'], url: '' },
      //{ label: event.parentEvent.title, routerLink: event.parentEvent.routerLink },
    ];
  });

  hasMoreDates = computed(() => {
    const dates = this.event$()?.eventDates;
    if (!dates) {
      return false;
    }
    return dates.length > 3;
  });

  showDateCount = signal(5);

  isShortText = computed(() => {
    const event = this.event$();
    const text = new StripHtmlPipe().transform(event?.text || '') || '';
    return text.length < 1000;
  });
}
